import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Pages/Services.css';

/* ══════════════════════════════════════
   GSAP LOADER  (CDN, no install needed)
══════════════════════════════════════ */
function loadGSAP() {
  return new Promise((resolve) => {
    if (window.gsap && window.ScrollTrigger) { resolve(); return; }
    const s1 = document.createElement('script');
    s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s1.onload = () => {
      const s2 = document.createElement('script');
      s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      s2.onload = () => { window.gsap.registerPlugin(window.ScrollTrigger); resolve(); };
      document.head.appendChild(s2);
    };
    document.head.appendChild(s1);
  });
}

/* ══════════════════════════════════════
   CUSTOM SVG ICONS — Services
══════════════════════════════════════ */
const IconSaaS = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="10" width="36" height="24" rx="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M16 34v4M32 34v4M10 38h28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="24" cy="22" r="5" stroke="currentColor" strokeWidth="2"/>
    <path d="M17 22h-4M35 22h-4M24 15v-4M24 33v-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="24" cy="22" r="2" fill="currentColor" opacity="0.4"/>
  </svg>
);
const IconCloud = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34 34H13a8 8 0 1 1 1.5-15.9A10 10 0 0 1 34 22a7 7 0 0 1 0 12z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M24 28v8M20 32l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="38" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="10" cy="14" r="2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M35 15l2-2M13 17l-2 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
const IconAgents = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="7" stroke="currentColor" strokeWidth="2"/>
    <circle cx="8"  cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
    <circle cx="40" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
    <circle cx="8"  cy="36" r="4" stroke="currentColor" strokeWidth="2"/>
    <circle cx="40" cy="36" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 14l8 7M36 14l-8 7M12 34l8-7M36 34l-8-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <circle cx="24" cy="24" r="2.5" fill="currentColor" opacity="0.5"/>
  </svg>
);
const IconIoT = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="16" y="20" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M11 16a18 18 0 0 1 26 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 20a12 12 0 0 1 18 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M24 36v4M20 40h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="24" cy="28" r="2.5" fill="currentColor" opacity="0.6"/>
    <path d="M20 28h-4M28 28h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
  </svg>
);
const IconAIOps = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 36l8-10 6 4 8-14 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="8"  cy="36" r="2.5" fill="currentColor" opacity="0.6"/>
    <circle cx="16" cy="26" r="2.5" fill="currentColor" opacity="0.6"/>
    <circle cx="22" cy="30" r="2.5" fill="currentColor" opacity="0.6"/>
    <circle cx="30" cy="16" r="2.5" fill="currentColor" opacity="0.6"/>
    <circle cx="38" cy="26" r="2.5" fill="currentColor" opacity="0.6"/>
    <rect x="6" y="38" width="36" height="2" rx="1" fill="currentColor" opacity="0.2"/>
    <path d="M36 10a4 4 0 0 1 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" opacity="0.5"/>
  </svg>
);
const IconVertical = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 42h36" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <rect x="8"  y="28" width="8"  height="14" rx="1" stroke="currentColor" strokeWidth="2"/>
    <rect x="20" y="20" width="8"  height="22" rx="1" stroke="currentColor" strokeWidth="2"/>
    <rect x="32" y="12" width="8"  height="30" rx="1" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 24l8-6 8-4 8-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 2"/>
    <circle cx="12" cy="24" r="2" fill="currentColor" opacity="0.6"/>
    <circle cx="24" cy="17" r="2" fill="currentColor" opacity="0.6"/>
    <circle cx="36" cy="10" r="2" fill="currentColor" opacity="0.6"/>
  </svg>
);
const IconTalent = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M24 16c6.627 0 12 2.686 12 6v4c0 3.314-5.373 6-12 6s-12-2.686-12-6v-4c0-3.314 5.373-6 12-6z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 28v4c0 3.314 5.373 6 12 6s12-2.686 12-6v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="16" cy="36" r="2" fill="currentColor" opacity="0.6"/>
    <circle cx="32" cy="36" r="2" fill="currentColor" opacity="0.6"/>
  </svg>
);
const IconSecurity = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4l16 6v12c0 10-16 16-16 16s-16-6-16-16v-12l16-6z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M24 20v8M20 24h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="24" cy="24" r="3" fill="currentColor" opacity="0.3"/>
  </svg>
);

const SERVICE_ICONS = [<IconSaaS/>,<IconCloud/>,<IconAgents/>,<IconTalent/>,<IconSecurity/>,<IconIoT/>,<IconAIOps/>,<IconVertical/>];

/* ── Vertical icons ── */
const IconHealth = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 30s-12-7-12-16a7 7 0 0 1 12-4.9A7 7 0 0 1 30 14c0 9-12 16-12 16z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M14 18h8M18 14v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconLogistics = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="12" width="22" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M24 18h6l4 6v2h-10V18z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="8"  cy="29" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="28" cy="29" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M6 12V8h12v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconRetail = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 8h24l-3 12H9L6 8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M9 20l-2 6h22l-2-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M14 8L12 4M22 8l2-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="13" cy="30" r="2" stroke="currentColor" strokeWidth="1.8"/>
    <circle cx="23" cy="30" r="2" stroke="currentColor" strokeWidth="1.8"/>
  </svg>
);
const IconFinance = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="14" stroke="currentColor" strokeWidth="2"/>
    <path d="M18 8v2M18 26v2M12 12l1.4 1.4M22.6 22.6l1.4 1.4M8 18h2M26 18h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M15 21a3 3 0 0 0 6 0c0-2-3-3-3-5s3-2 3-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M18 12v1M18 23v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconManufacturing = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="20" width="28" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="M4 20l7-12h14l7 12" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="12" cy="26" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="24" cy="26" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 8v4M18 6v6M24 8v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconEducation = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L4 14l14 8 14-8-14-8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8 18v8a10 4 0 0 0 20 0v-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M32 14v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="32" cy="24" r="2" stroke="currentColor" strokeWidth="1.8"/>
  </svg>
);

/* ── Process icons ── */
const ProcIcons = [
  <svg viewBox="0 0 32 32" fill="none"><path d="M6 10h20M6 16h14M6 22h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="26" cy="22" r="4" stroke="currentColor" strokeWidth="2"/><path d="M24 22l1.5 1.5L28 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg viewBox="0 0 32 32" fill="none"><rect x="4" y="4" width="24" height="24" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M10 16h12M16 10v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  <svg viewBox="0 0 32 32" fill="none"><rect x="6" y="8" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M11 16l3 3 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg viewBox="0 0 32 32" fill="none"><path d="M16 6v20M6 16h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="16" r="10" stroke="currentColor" strokeWidth="2"/><circle cx="16" cy="16" r="4" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2"/></svg>,
  <svg viewBox="0 0 32 32" fill="none"><path d="M6 26l6-8 5 4 7-12 4 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M26 6v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="10" stroke="currentColor" strokeWidth="2"/><path d="M16 10v6l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="4" r="2" fill="currentColor" opacity="0.5"/></svg>,
];

/* ── Tech stacks ── */
const techStacks = [
  { cat: 'AI / ML', icon: '🧠', color: '#3b82f6', items: ['TensorFlow','PyTorch','Hugging Face','LangChain','AutoML','OpenAI'] },
  { cat: 'Cloud',   icon: '☁️', color: '#56ccf2', items: ['AWS','Azure','GCP','Kubernetes','Docker','Terraform'] },
  { cat: 'Dev',     icon: '⌨️', color: '#7c6fe0', items: ['Python','Node.js','Java','Go','Rust','TypeScript'] },
  { cat: 'Data',    icon: '📊', color: '#10b981', items: ['Apache Spark','Kafka','PostgreSQL','MongoDB','Elasticsearch','Snowflake'] },
];

/* ══════════════════════════════════════
   PARTICLE CANVAS
══════════════════════════════════════ */
function ParticleField() {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current; if (!c) return;
    const ctx = c.getContext('2d'); let W,H,pts,raf;
    const resize = ()=>{ W=c.width=c.offsetWidth; H=c.height=c.offsetHeight; };
    const make = ()=>({ x:Math.random()*W, y:Math.random()*H, vx:(Math.random()-.5)*.25, vy:(Math.random()-.5)*.25, r:Math.random()*1.3+.3, a:Math.random()*.35+.07 });
    const init = ()=>{ resize(); pts=Array.from({length:55},make); };
    const draw = ()=>{
      ctx.clearRect(0,0,W,H);
      pts.forEach(p=>{ p.x+=p.vx; p.y+=p.vy; if(p.x<0)p.x=W; if(p.x>W)p.x=0; if(p.y<0)p.y=H; if(p.y>H)p.y=0; ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2); ctx.fillStyle=`rgba(47,128,237,${p.a})`; ctx.fill(); });
      for(let i=0;i<pts.length;i++) for(let j=i+1;j<pts.length;j++){
        const dx=pts[i].x-pts[j].x,dy=pts[i].y-pts[j].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<90){ctx.beginPath();ctx.moveTo(pts[i].x,pts[i].y);ctx.lineTo(pts[j].x,pts[j].y);ctx.strokeStyle=`rgba(47,128,237,${.1*(1-d/90)})`;ctx.lineWidth=.5;ctx.stroke();}
      }
      raf=requestAnimationFrame(draw);
    };
    init(); draw();
    window.addEventListener('resize',init);
    return ()=>{cancelAnimationFrame(raf);window.removeEventListener('resize',init);};
  },[]);
  return <canvas ref={ref} className="srv-canvas" aria-hidden />;
}

/* ══════════════════════════════════════
   SECTION HEADER
══════════════════════════════════════ */
function SectionHeader({ eyebrow, title, accent, sub }) {
  return (
    <div className="srv-section-header">
      {eyebrow && <span className="srv-eyebrow">{eyebrow}</span>}
      <h2 className="srv-section-title">{title} {accent && <span className="srv-accent">{accent}</span>}</h2>
      {sub && <p className="srv-section-sub">{sub}</p>}
    </div>
  );
}

/* ══════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════ */
const Services = () => {
  const pageRef     = useRef(null);
  const heroRef     = useRef(null);
  const processRef  = useRef(null);
  const techRef     = useRef(null);

  /* ── GSAP animations ── */
  useEffect(() => {
    loadGSAP().then(() => {
      const { gsap, ScrollTrigger } = window;

      gsap.fromTo('.srv-hero-content > *',
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out', delay: 0.2 }
      );

      gsap.fromTo('.srv-card',
        { opacity: 0, y: 60, scale: 0.96 },
        { opacity: 1, y: 0,  scale: 1,
          duration: 0.7, stagger: 0.1, ease: 'power3.out',
          scrollTrigger: { trigger: '.srv-cards-grid', start: 'top 80%' }
        }
      );

      gsap.utils.toArray('.vert-card').forEach((el, i) => {
        gsap.fromTo(el,
          { opacity: 0, x: i % 2 === 0 ? -50 : 50 },
          { opacity: 1, x: 0, duration: 0.65, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 82%' }
          }
        );
      });

      gsap.fromTo('.proc-step',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'back.out(1.4)',
          scrollTrigger: { trigger: '.proc-grid', start: 'top 78%' }
        }
      );

      gsap.fromTo('.proc-line',
        { scaleX: 0 },
        { scaleX: 1, duration: 1.2, ease: 'power2.inOut',
          scrollTrigger: { trigger: '.proc-grid', start: 'top 75%' }
        }
      );

      gsap.fromTo('.tech-cat',
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 0.6, stagger: 0.1, ease: 'power3.out',
          scrollTrigger: { trigger: '.tech-grid', start: 'top 80%' }
        }
      );

      gsap.fromTo('.tech-pill',
        { opacity: 0, scale: 0.7 },
        { opacity: 1, scale: 1, duration: 0.4, stagger: 0.04, ease: 'back.out(1.6)',
          scrollTrigger: { trigger: '.tech-grid', start: 'top 75%' }
        }
      );

      gsap.fromTo('.srv-cta-inner > *',
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.7, stagger: 0.12, ease: 'power3.out',
          scrollTrigger: { trigger: '.srv-cta-section', start: 'top 82%' }
        }
      );

      gsap.utils.toArray('.srv-section-header').forEach(el => {
        gsap.fromTo(el,
          { opacity: 0, y: 32 },
          { opacity: 1, y: 0, duration: 0.65, ease: 'power3.out',
            scrollTrigger: { trigger: el, start: 'top 85%' }
          }
        );
      });

      /* SaaS section animations */
      gsap.fromTo('.saas-intro-card',
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out',
          scrollTrigger: { trigger: '.saas-intro-card', start: 'top 82%' }
        }
      );

      gsap.fromTo('.aiaas-capability-card',
        { opacity: 0, y: 50, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.08, ease: 'power3.out',
          scrollTrigger: { trigger: '.aiaas-capabilities-grid', start: 'top 80%' }
        }
      );

      gsap.fromTo('.aiaas-step',
        { opacity: 0, x: -40 },
        { opacity: 1, x: 0, duration: 0.6, stagger: 0.12, ease: 'power3.out',
          scrollTrigger: { trigger: '.aiaas-steps', start: 'top 82%' }
        }
      );

      gsap.fromTo('.haas-card',
        { opacity: 0, y: 50, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.08, ease: 'power3.out',
          scrollTrigger: { trigger: '.haas-grid', start: 'top 80%' }
        }
      );

      gsap.fromTo('.haas-benefit',
        { opacity: 0, x: 30 },
        { opacity: 1, x: 0, duration: 0.5, stagger: 0.1, ease: 'power3.out',
          scrollTrigger: { trigger: '.haas-benefits', start: 'top 82%' }
        }
      );

      gsap.fromTo('.synergy-card',
        { opacity: 0, scale: 0.9, y: 30 },
        { opacity: 1, scale: 1, y: 0, duration: 0.7, ease: 'back.out(1.3)',
          scrollTrigger: { trigger: '.srv-synergy-section', start: 'top 80%' }
        }
      );

    });

    return () => {
      if (window.ScrollTrigger) window.ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  const mainServices = [
    { title: 'AI-powered B2B SaaS', desc: 'AI-augmented tools and micro‑SaaS solutions for business automation and intelligence.',
      features: ['Developer productivity tools (test generation, code review)','Customer support: help desk, chatbots, self-service portals','AI Skills benchmarking platforms','Vertical AI tools for workforce readiness'], num: '01' },
    { title: 'Cloud-Native Engineering', desc: 'Cloud migrations, optimization, and AI-ready infrastructure for hyperscalers.',
      features: ['AWS, Azure, GCP migrations & optimization','Kubernetes, CI/CD & observability','Security hardening for cloud environments','Architecting AI workloads (vector DBs, GPU scheduling, MLOps)'], num: '02' },
    { title: 'Engineering Services Outsourcing', desc: 'Specialized engineering services for niche industries while maintaining fixed costs.',
      features: ['Industrial & manufacturing software (simulation, IIoT dashboards)','Energy & sustainability (monitoring, digital twins)','AI-driven multimedia solutions','Telecom & networking solutions'], num: '03' },
    { title: 'E2E AI Evaluation & Talent Platforms', desc: 'Comprehensive AI-driven evaluation systems and talent management solutions.',
      features: ['AI Skills assessment and benchmarking','Talent evaluation and matching','Workforce readiness tracking','Industry certification validation'], num: '04' },
    { title: 'Cybersecurity & Compliance Software', desc: 'Enterprise-grade security and compliance solutions powered by AI.',
      features: ['AI-driven threat detection','Compliance automation (SOC2, GDPR, HIPAA)','Risk assessment & mitigation','Security monitoring & incident response'], num: '05' },
    { title: 'Enterprise AI (Self-Hosted, On-Prem)', desc: 'Private AI systems designed for enterprises that cannot send data to cloud providers.',
      features: ['LLM deployment & optimization (Llama, Mistral, DeepSeek)','Retrieval-Augmented Generation (RAG) systems','Compliance-ready AI (SOC2, GDPR, HIPAA)','AI copilots for enterprise workflows'], num: '06' },
    { title: 'AI for DevOps (AIOps)', desc: 'Intelligent operations that predict incidents, reduce MTTR, and optimize infrastructure costs.',
      features: ['Incident prediction using AI','AI root-cause analysis','Intelligent monitoring & log anomaly detection','Cost optimization engines for AWS/Azure'], num: '07' },
    { title: 'Industry-Specific AI Solutions', desc: 'Vertical SaaS solutions tailored to specific industries and use cases.',
      features: ['Healthcare: reports automation, prior auth, RCM AI','Manufacturing: predictive maintenance','Logistics: route optimization, demand forecasting','Retail: computer vision, inventory tracking'], num: '08' },
  ];

  const verticals = [
    { icon: <IconHealth/>,       name: 'Healthcare',         color: '#ef4444', desc: 'Transform patient care and operational efficiency with AI.', solutions: ['AI diagnostic assistance','Patient outcome prediction','Clinical workflow optimisation','Medical imaging analysis'] },
    { icon: <IconLogistics/>,    name: 'Logistics',          color: '#f59e0b', desc: 'Optimise supply chains and delivery networks end-to-end.', solutions: ['Route optimisation algorithms','Demand forecasting models','Warehouse automation','Last-mile delivery optimisation'] },
    { icon: <IconRetail/>,       name: 'Retail',             color: '#8b5cf6', desc: 'Enhance customer experience and drive revenue with AI.', solutions: ['Product recommendation engines','Inventory optimisation','Customer analytics platforms','Dynamic pricing systems'] },
    { icon: <IconFinance/>,      name: 'Financial Services', color: '#10b981', desc: 'Manage risk and fraud at enterprise scale.', solutions: ['Fraud detection systems','Credit risk modelling','Trading algorithm development','Compliance automation'] },
    { icon: <IconManufacturing/>,name: 'Manufacturing',      color: '#3b82f6', desc: 'Increase productivity and reduce costly downtime.', solutions: ['Predictive maintenance','Quality control automation','Production optimisation','Supply chain forecasting'] },
    { icon: <IconEducation/>,    name: 'Education',          color: '#ec4899', desc: 'Personalise learning and measure outcomes at scale.', solutions: ['Adaptive learning platforms','Student performance prediction','Content personalisation','Learning analytics dashboards'] },
  ];

  const process = [
    { label: 'Requirements Analysis', desc: 'Deep-dive into your goals and technical landscape.' },
    { label: 'Solution Design',        desc: 'Architect the optimal solution for your constraints.' },
    { label: 'Development',            desc: 'Build and test with agile, AI-assisted workflows.' },
    { label: 'Deployment',             desc: 'Safe rollout with blue-green & canary strategies.' },
    { label: 'Optimisation',           desc: 'Continuous improvement driven by real usage data.' },
    { label: '24/7 Support',           desc: 'Always-on monitoring and dedicated account team.' },
  ];

  const aiCapabilities = [
    { num: '01', title: 'Custom ML Models', desc: 'Tailored solutions for your business challenges — predictive analytics, recommendation engines, customer behavior modeling, and more.' },
    { num: '02', title: 'Natural Language Processing', desc: 'Extract insights, automate support, and build smarter chatbots with our NLP APIs. We support multilingual and domain-specific models.' },
    { num: '03', title: 'Computer Vision', desc: 'Image and video recognition systems for quality control, security, logistics, and retail. Real-time or batch — you choose.' },
    { num: '04', title: 'Automation & RPA', desc: 'Automate repetitive tasks, from document processing to lead routing. Reduce human error, improve response time.' },
    { num: '05', title: 'Data Intelligence & Insights', desc: 'AI-powered dashboards, trend forecasting, anomaly detection — all in one place.' },
  ];

  const aiSteps = [
    { num: '01', title: 'Select a Solution', desc: 'Choose from our suite of ready-to-use AI modules or request a custom build.' },
    { num: '02', title: 'Connect via API', desc: 'Integrate effortlessly into your stack using secure, RESTful APIs.' },
    { num: '03', title: 'Deploy, Scale, Adapt', desc: 'Monitor usage, performance, and retrain models as needed — all in real time.' },
  ];

  const haasServices = [
    { num: '01', title: 'Human-in-the-Loop (HITL)', desc: 'Inject real-time human review into your AI pipelines — image classification, NLP moderation, edge-case handling.' },
    { num: '02', title: 'Data Labeling & Annotation', desc: 'High-accuracy, scalable data annotation for AI training sets — bounding boxes, segmentation, sentiment tagging, and more.' },
    { num: '03', title: 'Customer Support Teams', desc: 'Trained agents to handle live chat, email, and technical support across multiple languages and time zones.' },
    { num: '04', title: 'Virtual Assistance & BPO', desc: 'Back-office operations, scheduling, content moderation, research tasks — handled by vetted, remote-ready professionals.' },
    { num: '05', title: 'Custom Workflow Ops', desc: 'Build your own workflow: combine tools, tasks, and human operators for complete process automation.' },
  ];

  const haasBenefits = [
    { label: 'Scalable Workforce', desc: 'Scale up or down as your needs change' },
    { label: 'Quality Assurance', desc: 'Dual-layer QA systems for maximum accuracy' },
    { label: 'Time-Zone Coverage', desc: 'Operate 24/7 across regions' },
    { label: 'Flexible Pricing', desc: 'Pay only for what you use' },
  ];

  return (
    <div className="services-page" ref={pageRef}>

      {/* ════════════════════ HERO ════════════════════ */}
      <section className="srv-hero" ref={heroRef}>
        <ParticleField />
        <div className="srv-grid-bg" aria-hidden />
        <div className="srv-glow srv-glow-l" aria-hidden />
        <div className="srv-glow srv-glow-r" aria-hidden />
        <div className="srv-hero-inner">
          <div className="srv-hero-content">
            <span className="srv-hero-eyebrow">
              <span className="srv-eyebrow-dot" />
              Enterprise Solutions · 6 Service Pillars
            </span>
            <h1 className="srv-hero-title">
              Our <span className="srv-hero-accent">Services</span>
            </h1>
            <p className="srv-hero-sub">
              Comprehensive AI and engineering solutions for enterprise digital transformation —
              from intelligent SaaS to fully autonomous AI agent ecosystems.
            </p>
            <div className="srv-hero-tags">
              {['AI-First','Cloud-Native','Enterprise-Grade','24/7 Support'].map(t => (
                <span key={t} className="srv-hero-tag">{t}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="srv-hero-cut" aria-hidden />
      </section>

      {/* ════════════════════ CORE SERVICES ════════════════════ */}
      <section className="srv-services-section">
        <div className="srv-container">
          <SectionHeader eyebrow="◈ Core Offerings" title="Eight Service" accent="Pillars" sub="Each pillar is a full practice area — not a feature list." />
          <div className="srv-cards-grid">
            {mainServices.map((s, i) => (
              <div key={i} className="srv-card" style={{ '--accent': `var(--svc-${i})` }}>
                <div className="srv-card-num">{s.num}</div>
                <div className="srv-card-icon">{SERVICE_ICONS[i]}</div>
                <h3 className="srv-card-title">{s.title}</h3>
                <p className="srv-card-desc">{s.desc}</p>
                <ul className="srv-card-features">
                  {s.features.map((f, fi) => (
                    <li key={fi} className="srv-feature">
                      <span className="srv-check" aria-hidden>✓</span>
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="srv-card-glow" aria-hidden />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════ SAAS SECTION ════════════════════ */}
      <section className="srv-saas-section">
        <div className="srv-container">
          <SectionHeader eyebrow="💼 Software as a Service" title="Your Smartest Business" accent="Move Starts Here" sub="A new kind of SaaS — fusing cutting-edge AI with human insight, without the overhead." />

          {/* Intro card */}
          <div className="saas-intro-card">
            <div className="saas-intro-glow" aria-hidden />
            <div className="saas-intro-content">
              <p className="saas-intro-text">
                At <strong>IncogniFlex Services</strong>, we provide a new kind of SaaS — one that fuses the best of artificial intelligence and human insight. Our platform gives you access to cutting-edge tools and expert support, without the overhead.
              </p>
              <p className="saas-intro-text">
                Whether you're looking to automate complex tasks or need real human support to power your operations, we've got you covered.
              </p>
            </div>
            <div className="saas-intro-pillars">
              <div className="saas-pillar">
                <span className="saas-pillar-icon">🤖</span>
                <span className="saas-pillar-label">AI as a Service</span>
                <span className="saas-pillar-sub">AIaaS</span>
              </div>
              <div className="saas-pillar-divider">+</div>
              <div className="saas-pillar">
                <span className="saas-pillar-icon">🧑‍💼</span>
                <span className="saas-pillar-label">Humans as a Service</span>
                <span className="saas-pillar-sub">HaaS</span>
              </div>
            </div>
          </div>

          {/* ── AIaaS Sub-section ── */}
          <div className="srv-subsection">
            <div className="srv-subsection-header">
              <span className="srv-subsection-badge" style={{ '--sb': 'var(--blue)' }}>🤖 AI as a Service (AIaaS)</span>
              <h3 className="srv-subsection-title">AI You Can Plug In — <span className="srv-accent">And Trust</span></h3>
              <p className="srv-subsection-sub">Our AIaaS offerings give you direct access to powerful machine learning capabilities, delivered securely through the cloud. No need to build complex infrastructure — we bring the tech to you.</p>
            </div>

            <div className="srv-sub-label">
              <span className="srv-sub-label-line" />
              <span>🚀 Key AIaaS Capabilities</span>
              <span className="srv-sub-label-line" />
            </div>

            <div className="aiaas-capabilities-grid">
              {aiCapabilities.map((cap, i) => (
                <div key={i} className="aiaas-capability-card">
                  <span className="aiaas-cap-num">{cap.num}</span>
                  <h4 className="aiaas-cap-title">{cap.title}</h4>
                  <p className="aiaas-cap-desc">{cap.desc}</p>
                  <div className="aiaas-cap-glow" aria-hidden />
                </div>
              ))}
            </div>

            <div className="srv-sub-label" style={{ marginTop: '3rem' }}>
              <span className="srv-sub-label-line" />
              <span>🛠️ How It Works</span>
              <span className="srv-sub-label-line" />
            </div>

            {/* <div className="aiaas-steps">
              {aiSteps.map((step, i) => (
                <div key={i} className="aiaas-step">
                  <div className="aiaas-step-num">{step.num}</div>
                  <div className="aiaas-step-body">
                    <h4 className="aiaas-step-title">{step.title}</h4>
                    <p className="aiaas-step-desc">{step.desc}</p>
                  </div>
                  {i < aiSteps.length - 1 && <div className="aiaas-step-arrow">→</div>}
                </div>
              ))}
            </div> */}

            <div className="srv-subsection-cta">
              <Link to="/contact" className="srv-cta-btn primary">
                <span>Book a Demo</span>
                <span className="cta-btn-arrow">→</span>
              </Link>
              <Link to="/docs" className="srv-cta-btn secondary">Explore API Docs</Link>
            </div>
          </div>

          {/* ── HaaS Sub-section ── */}
          <div className="srv-subsection srv-subsection--haas">
            <div className="srv-subsection-header">
              <span className="srv-subsection-badge" style={{ '--sb': 'var(--cyan)' }}>🧑‍💼 Humans as a Service (HaaS)</span>
              <h3 className="srv-subsection-title">Because Some Things Still Need <span className="srv-accent">a Human Touch</span></h3>
              <p className="srv-subsection-sub">Not every task can be automated — and not every automation runs perfectly on its own. That's where HaaS comes in. We provide on-demand human expertise to complement your AI systems or power operations independently.</p>
            </div>

            <div className="srv-sub-label">
              <span className="srv-sub-label-line" />
              <span>🧩 HaaS Service Offerings</span>
              <span className="srv-sub-label-line" />
            </div>

            <div className="haas-grid">
              {haasServices.map((svc, i) => (
                <div key={i} className="haas-card">
                  <span className="haas-card-num">{svc.num}</span>
                  <h4 className="haas-card-title">{svc.title}</h4>
                  <p className="haas-card-desc">{svc.desc}</p>
                  <div className="haas-card-glow" aria-hidden />
                </div>
              ))}
            </div>

            <div className="srv-sub-label" style={{ marginTop: '3rem' }}>
              <span className="srv-sub-label-line" />
              <span>💡 Why HaaS?</span>
              <span className="srv-sub-label-line" />
            </div>

            <div className="haas-benefits">
              {haasBenefits.map((b, i) => (
                <div key={i} className="haas-benefit">
                  <span className="haas-benefit-check">✅</span>
                  <div>
                    <span className="haas-benefit-label">{b.label}</span>
                    <span className="haas-benefit-sep"> – </span>
                    <span className="haas-benefit-desc">{b.desc}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="srv-subsection-cta">
              <Link to="/contact" className="srv-cta-btn primary">
                <span>Request Human Ops Support</span>
                <span className="cta-btn-arrow">→</span>
              </Link>
              <Link to="/contact" className="srv-cta-btn secondary">Build Your Workflow</Link>
            </div> */}
          </div>
        </div>
      </section>

      {/* ════════════════════ SYNERGY SECTION ════════════════════ */}
      <section className="srv-synergy-section">
        <div className="srv-container">
          <SectionHeader eyebrow="🧠 The Power of Human + AI" title="Individually Powerful —" accent="Unstoppable Together" sub="Our SaaS model lets you blend automation with human intelligence, delivering faster results, better accuracy, and improved ROI." />
          <div className="synergy-cards">
            <div className="synergy-card synergy-card--ai">
              <div className="synergy-card-icon">🤖</div>
              <h3 className="synergy-card-title">AI Automation</h3>
              <p className="synergy-card-desc">Speed, scale, and consistency at a fraction of the cost. Always on, never fatigued.</p>
              <ul className="synergy-list">
                <li>24/7 availability</li>
                <li>Instant scalability</li>
                <li>Consistent accuracy</li>
                <li>Zero operational fatigue</li>
              </ul>
            </div>
            <div className="synergy-plus">
              <div className="synergy-plus-inner">+</div>
            </div>
            <div className="synergy-card synergy-card--human">
              <div className="synergy-card-icon">🧑‍💼</div>
              <h3 className="synergy-card-title">Human Expertise</h3>
              <p className="synergy-card-desc">Judgment, empathy, and adaptability that no model can fully replicate — yet.</p>
              <ul className="synergy-list">
                <li>Contextual judgment</li>
                <li>Edge-case handling</li>
                <li>Creative problem solving</li>
                <li>Empathetic communication</li>
              </ul>
            </div>
            <div className="synergy-equals">=</div>
            <div className="synergy-card synergy-card--result">
              <div className="synergy-card-icon">🚀</div>
              <h3 className="synergy-card-title">Superior Results</h3>
              <p className="synergy-card-desc">Faster outcomes, better accuracy, and measurable ROI — built for the real world.</p>
              <ul className="synergy-list">
                <li>Higher throughput</li>
                <li>Improved accuracy</li>
                <li>Reduced costs</li>
                <li>Scalable operations</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ════════════════════ VERTICALS ════════════════════ */}
      <section className="srv-verticals-section">
        <div className="srv-container">
          <SectionHeader eyebrow="🏭 Industry Verticals" title="Built for Your" accent="Industry" sub="Purpose-built AI for six major verticals — not generic adaptations." />
          <div className="srv-vert-grid">
            {verticals.map((v, i) => (
              <div key={i} className="vert-card" style={{ '--vc': v.color }}>
                <div className="vert-icon-wrap" style={{ borderColor: v.color + '44', background: v.color + '15' }}>
                  <div className="vert-icon" style={{ color: v.color }}>{v.icon}</div>
                </div>
                <div className="vert-body">
                  <h3 className="vert-name">{v.name}</h3>
                  <p className="vert-desc">{v.desc}</p>
                  <ul className="vert-list">
                    {v.solutions.map((sol, si) => (
                      <li key={si} className="vert-sol">
                        <span className="vert-bullet" style={{ background: v.color }} />
                        {sol}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="vert-border-accent" style={{ background: `linear-gradient(90deg, ${v.color}, transparent)` }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════ PROCESS ════════════════════ */}
      <section className="srv-process-section">
        <div className="srv-container">
          <SectionHeader eyebrow="⚡ How We Work" title="Implementation" accent="Process" sub="Six phases from discovery to continuous optimisation." />
          <div className="proc-grid" ref={processRef}>
            <div className="proc-line" aria-hidden />
            {process.map((p, i) => (
              <div key={i} className="proc-step">
                <div className="proc-step-num">{String(i + 1).padStart(2,'0')}</div>
                <div className="proc-icon-wrap">
                  {ProcIcons[i]}
                </div>
                <h4 className="proc-title">{p.label}</h4>
                <p className="proc-desc">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════ TECH STACK ════════════════════ */}
      <section className="srv-tech-section">
        <div className="srv-container">
          <SectionHeader eyebrow="🔧 Technology" title="Our" accent="Tech Stack" sub="Best-in-class tools across every layer of the modern AI stack." />
          <div className="tech-grid" ref={techRef}>
            {techStacks.map((cat, ci) => (
              <div key={ci} className="tech-cat" style={{ '--tc': cat.color }}>
                <div className="tech-cat-header">
                  <span className="tech-cat-icon">{cat.icon}</span>
                  <h4 className="tech-cat-name">{cat.cat}</h4>
                  <div className="tech-cat-line" style={{ background: cat.color }} />
                </div>
                <div className="tech-pills">
                  {cat.items.map((item, ii) => (
                    <span key={ii} className="tech-pill" style={{ '--pc': cat.color }}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════ CTA ════════════════════ */}
      <section className="srv-cta-section">
        <div className="srv-cta-glow" aria-hidden />
        <div className="srv-cta-grid-bg" aria-hidden />
        <div className="srv-container">
          <div className="srv-cta-inner">
            <span className="srv-cta-eyebrow">
              <span className="srv-eyebrow-dot" />
              Let's Get to Work
            </span>
            <h2 className="srv-cta-title">Ready to <span className="srv-accent">Get Started?</span></h2>
            <p className="srv-cta-sub">
              Whether you're just starting with AI or scaling a global operation, we're ready to help. Let's create smarter systems — together.
            </p>
            <div className="srv-cta-actions">
              <a href="mailto:aiprosevice@gmail.com" className="srv-cta-btn primary">
                <span>Talk to an Expert</span>
                <span className="cta-btn-arrow">→</span>
              </a>
            </div>
            <p className="srv-cta-note">No commitment required · Response within 24 hours</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Services;